<template>
  <router-link :to="{ name: 'candidate-tests' }" class="telegram">
    <div class="icon">
      <b-icon-question-circle />
    </div>
    <div class="text">
      Пройдіть тестування, яке допоможе нашій команді визначити
      <strong> рівень Вашої підготовки</strong>
    </div>
  </router-link>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.telegram {
  padding: 20px;
  background: #ffc602;
  border-radius: 8px;
  box-shadow: 0px 6px 14px 0px rgba(#ffc602, 0.3);
  min-height: 100%;
  display: flex;
  text-decoration: none;
  color: #000;
  align-items: center;
  transition: 0.3s;
  .icon {
    font-size: 72px;
    margin-right: 30px;
  }
  &:hover {
    background: lighten(#ffc602, 5%);
    transition: 0.3s;
  }
}
</style>
